import { getAuthData } from "../../../services/storage/LocalStorage";
import {
  DEV1, FRONTM_AI_DOMAIN, INFORM_FRONTM, INFORM_SEA_DANCE, INFOTAIN, ONSHIP_PROD_URL, ONSHIP_STAGE_URL, PAL_CARE_DEV2,
  SEA_DANCE_DOMAIN, SEA_DANCE_FRONTM_DOMAIN, SEAMEDEX_PRODUCTION, SEAMEDEX_STAGE, VIKAND_PROD_URL, VIKAND_STAGE_URL, STAGE_ONSHIP_URL,
  VIKAND_STAGE_2_URL, VIKAND_CONNECT,
  INTELSAT_PROD_URL,
  INTELSAT_STAGE_URL,
  LEDGID_DEV,
  LEDGID_STAGE,
  STAGE_CREW_MATTERS,
  CREW_MATTERS
} from "../../DomainsHelper";
import config from "../config";


const getCurrentHostname = () => {
  try {
    return new URL(window.location.href).hostname;
  } catch (error) {
    console.error("Invalid domain URL:", error);
    return "";
  }
};

const getDomainStatus = (targetDomain) => {
  const hostname = getCurrentHostname();
  return hostname === targetDomain;
};

const domainConfigMap = [
  { domain: LEDGID_DEV, type: config.ledgidAppType },
  { domain: LEDGID_STAGE, type: config.ledgidAppType },
  { domain: INTELSAT_PROD_URL, type: config.intelsatAppType },
  { domain: INTELSAT_STAGE_URL, type: config.intelsatAppType },
  { domain: VIKAND_STAGE_URL, type: config.vikandWebAppType },
  { domain: VIKAND_PROD_URL, type: config.vikandWebAppType },
  { domain: VIKAND_STAGE_2_URL, type: config.vikandWebAppType },
  { domain: PAL_CARE_DEV2, type: config.onshipAppType },
  { domain: SEA_DANCE_FRONTM_DOMAIN, type: config.seadanceAppType },
  { domain: INFORM_FRONTM, type: config.seadanceAppType },
  { domain: INFORM_SEA_DANCE, type: config.seadanceAppType },
  { domain: DEV1, type: config.onshipAppType },
  { domain: ONSHIP_STAGE_URL, type: config.onshipAppType },
  { domain: SEA_DANCE_DOMAIN, type: config.seamedexAppType },
  { domain: SEAMEDEX_STAGE, type: config.seamedexAppType },
  { domain: SEAMEDEX_PRODUCTION, type: config.seamedexAppType },
  { domain: INFOTAIN, type: config.onshipAppType },
  { domain: ONSHIP_PROD_URL, type: config.onshipAppType },
  { domain: FRONTM_AI_DOMAIN, type: config.onshipAppType },
  { domain: STAGE_ONSHIP_URL, type: config.onshipAppType },
  { domain: VIKAND_CONNECT, type: config.vikandWebAppType },
  { domain: STAGE_CREW_MATTERS, type: config.crewmattersAppType },
  { domain: CREW_MATTERS, type: config.crewmattersAppType },
];

const authCodeMap = {
  [config.onshipAppType]: config.onshipDomain,
  [config.crewmattersAppType]: config.crewMattersDomain,
};

export const appType =
  domainConfigMap.find(({ domain }) => getDomainStatus(domain))?.type ??
  config.stationoneAppType;

export const getCurrentAuthCode = () => {
  return authCodeMap[appType] || null;
};  

export const Headers = () => {
  const authData = getAuthData()
  if (!authData?.auth?.sessionId) console.error("SessionId is mising in API headers")
  return {
    'sessionId': authData?.auth?.sessionId || '',
  }
};